import { cn } from '../lib/cn'
import type { OrderStatus } from '../api/endpoints'

const STATUS_STYLES: Record<OrderStatus, string> = {
  created: 'bg-saffron/20 text-amber border border-amber/40',
  paid: 'bg-forest/10 text-forest border border-forest/30',
  delivered: 'bg-blue-50 text-blue-700 border border-blue-200',
  cancelled: 'bg-red-50 text-danger border border-red-200',
  returned: 'bg-purple-100 text-purple-700 border border-purple-200',
}

export function StatusBadge({ status }: { status: OrderStatus }) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium capitalize',
        STATUS_STYLES[status],
      )}
    >
      <span className="size-1.5 rounded-full bg-current" />
      {status}
    </span>
  )
}

const ROLE_STYLES: Record<'customer' | 'admin' | 'author', string> = {
  customer: 'bg-sand text-ink border border-line',
  admin: 'bg-forest/10 text-forest border border-forest/30',
  author: 'bg-saffron/20 text-amber border border-amber/40',
}

export function RoleBadge({ role }: { role: 'customer' | 'admin' | 'author' }) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-md px-2 py-0.5 text-xs font-medium uppercase tracking-wider',
        ROLE_STYLES[role],
      )}
    >
      {role}
    </span>
  )
}

const AFFILIATE_STATUS_STYLES: Record<'active' | 'suspended' | 'banned', string> = {
  active: 'bg-forest/10 text-forest border border-forest/30',
  suspended: 'bg-amber/10 text-amber border border-amber/40',
  banned: 'bg-red-50 text-danger border border-red-200',
}

export function AffiliateStatusBadge({ status }: { status: 'active' | 'suspended' | 'banned' }) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium capitalize',
        AFFILIATE_STATUS_STYLES[status],
      )}
    >
      <span className="size-1.5 rounded-full bg-current" />
      {status}
    </span>
  )
}
